import { ArrowRight, PlayCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { heroImage, stats } from '../mock';

export default function Hero() {
  return (
    <section className="relative min-h-screen bg-[#0b0b0d] text-white overflow-hidden noise">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Arc welding sparks"
          className="h-full w-full object-cover opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0b0b0d] via-[#0b0b0d]/85 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0d] via-transparent to-[#0b0b0d]/60" />
      </div>

      {/* Grid pattern */}
      <div className="absolute inset-0 bg-grid opacity-40" />

      {/* Glowing orb */}
      <div className="absolute -right-40 top-1/3 h-[520px] w-[520px] rounded-full bg-amber-500/20 blur-3xl animate-flicker pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-24">
        <div className="max-w-3xl animate-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full border border-amber-500/30 bg-amber-500/5 px-4 py-1.5 mb-8">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse" />
            <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-300">
              Manufactured in Kota, Rajasthan
            </span>
          </div>

          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-semibold leading-[1.02]">
            Crafted for the
            <br />
            <span className="text-amber-400">Perfect Weld.</span>
          </h1>

          <p className="mt-7 text-lg lg:text-xl text-white/70 leading-relaxed max-w-2xl">
            Since 1985, <span className="text-white font-medium">Prakash Electrodes Private Limited</span> has
            manufactured premium welding rods trusted by India&rsquo;s toughest industries.
            Precision, durability, and performance in every arc.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link to="/products">
              <Button
                size="lg"
                className="btn-primary bg-amber-500 hover:bg-amber-500 text-[#0b0b0d] font-semibold h-12 px-7 rounded-md group"
              >
                Explore Products
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <Link to="/about">
              <Button
                size="lg"
                variant="ghost"
                className="text-white hover:text-amber-400 hover:bg-white/5 h-12 px-6 rounded-md"
              >
                <PlayCircle className="mr-2 h-5 w-5" /> Our Story
              </Button>
            </Link>
          </div>
        </div>

        {/* Stats bar */}
        <div className="relative mt-24 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-xl overflow-hidden backdrop-blur">
          {stats.map((s) => (
            <div key={s.label} className="bg-[#0b0b0d]/70 px-6 py-6">
              <div className="font-display text-3xl lg:text-4xl font-semibold text-amber-400">
                {s.value}
              </div>
              <div className="mt-1 text-xs uppercase tracking-[0.14em] text-white/60 font-mono">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[11px] font-mono uppercase tracking-[0.2em] text-white/40">
        Scroll to discover
      </div>
    </section>
  );
}
